import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Database } from '../../providers/database';
import { EventData } from '../../providers/event';
import { AuthData } from '../../providers/auth';

@Component({
  selector: 'page-event-cart',
  templateUrl: 'event-cart.html',
})
export class EventCart {

  obs: any;
  client: any;
  event: any;
  dataCart: any;
  paymentData: any;
  total: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database, public auth: AuthData, public eventProvider: EventData) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');

    this.obs = this.eventProvider.getCatalogBadge(this.client, this.auth.getUser().uid).subscribe((data) => {
      this.dataCart = data;
      this.total = 0;
      this.dataCart.forEach((element: any) => {
        this.total += parseInt(element.price) * parseInt(element.quantity);
      });
    });

    if (this.event.paymentMethod) {
      this.db.getData('/Clients/' + this.client.url + '/PaymentMethods/' + this.event.paymentMethod)
      .then((result: any) => {
        this.paymentData = result.val();
      });
    }
  }

  deleteItem(item, key) {
    this.db.deleteData('/Clients/' +  this.client.url + '/___CartUsers/' + this.auth.getUser().uid + '/' + item.id)
    .catch(error => {
      console.log('error al eliminar')
    });
  }

  closeListener() {
    if (this.obs) {
      console.log('Se eliminan los observables de cart');
      this.obs.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-cart/event-cart.ts